export default __webpack_public_path__ + "static/media/element_68.71c672da.jpg";